<template>
  <div class="panel">
    <div class="head">
      <div class="head-title">
        联系我们
      </div>
    </div>
    <div class="head-split"></div>
    <div class="body">
      <div class="contact-us-panel">
        <span class="normal">客服电话</span>
        <span class="normal-value">400-602-1010</span>
        <span class="normal">客服邮箱</span>
        <span class="normal-value">ykt@yicai.com</span>
        <span class="normal">微信扫一扫，使用大咖端小程序</span>
        <div class="miniqr"></div>
        <div class="normal">微信绑定提醒</div>
        <div class="qr"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactUsPanel',
  components: {}
}
</script>

<style lang="scss" scoped>
.panel {
  padding: 0px 30px 30px 30px;
}

.head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 59px;
}

.head-split {
  height: 1px;
  background-color: #ebebeb;
}

.head-title {
  font-family: MicrosoftYaHei;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  line-height: 16px;
  letter-spacing: 0px;
  color: #262626;
}

.contact-us-panel {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
}

.normal {
  padding-top: 25px;
  padding-left: 20px;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 20px;
  letter-spacing: 1px;
  color: #262626;
}

.normal-value {
  margin-top: 5px;
  font-size: 14px;
  padding-left: 20px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 20px;
  letter-spacing: 1px;
  color: #858585;
}

.qr {
  width: 150px;
  height: 152px;
  border: solid 1px #ebebeb;
  background: url('~@/assets/images/course/temp.png') no-repeat center;
  background-size: cover;
  margin-left: 20px;
  margin-top: 12px;
}

.miniqr {
  width: 150px;
  height: 152px;
  border: solid 1px #ebebeb;
  background: url('~@/assets/images/course/minipro.jpg') no-repeat center;
  background-size: cover;
  margin-left: 20px;
  margin-top: 12px;
}
</style>
